export class SaveOutsideSurveyUnitInfoDto {
  surveyId: string;
  buildingId: string;
  buildingType: number;
  numberOfFloors: number;
  studentHomeCount: number;
  numberOfLu: number;
  numberOfBu: number;
  numberOfSu: number;
  numberOfMBu: number;
  numberOfLBu: number;
  changeAddressTypes: SaveOutsideSurveyUnitInfoAddressTypeDto[];

  deserialize(input: any): this {
    Object.assign(this, input);
    this.numberOfLu = input["numberOfLivingUnits"];
    this.numberOfBu = input["numberOfBusinessUnits"];
    this.numberOfSu = input["numberOfServiceUnits"];
    return this;
  }
}

export class SaveOutsideSurveyUnitInfoAddressTypeDto {
  addressId: string;
  addressType: number;
  studentHomeCount: number;

  constructor(
    addressId?: string,
    addressType?: number,
    studentHomeCount?: number
  ) {
    this.addressId = addressId;
    this.addressType = addressType;
    this.studentHomeCount = studentHomeCount;
  }
}
